<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: $t(modalTitle),
      bgColor: 'secondary',
      textColor: 'white',
    }"
    :card="{ class: 'creation-date-modal' }"
    size="xs"
    :quasar-props="{ maximized: false }"
  >
    <template #body>
      <VDatePicker
        v-if="opened && mode === 'single'"
        v-model="dateInternal"
        :first-day-of-week="2"
        class="extracadabra-calendar q-mt-md"
        expanded
        :min-date="minDate"
        :mode="mode"
        color="orange"
        borderless
        :locale="DEFAULT_LANGUAGE"
        @dayclick="onDaySelection"
      />
      <VDatePicker
        v-if="opened && mode !== 'single'"
        v-model.range="dateInternal"
        :first-day-of-week="2"
        class="extracadabra-calendar q-mt-md"
        expanded
        :min-date="minDate"
        :mode="mode"
        color="orange"
        borderless
        :locale="DEFAULT_LANGUAGE"
        @dayclick="onDaySelection"
      />

      <p v-if="shouldShowHelper" class="creation-date-modal-helper">
        {{ $t(helperText) }}
      </p>
      <p v-if="mode === 'range'" class="creation-date-modal-helper">
        {{ $t("ETAB.PAGES.DEMANDS.CREATION.@DATE_MODAL_REST_LATER") }}
      </p>
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { ExtracadabraModal } from "@core/components/modals";
  import { DEFAULT_LANGUAGE } from "@core/constants";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      dates: {
        type: Object,
        default: null,
      },
      date: {
        type: Object,
        default: null,
      },
      minDate: {
        type: Date,
        default: null,
      },
      mode: {
        type: String,
        default: "single",
      },
    },
    emits: ["setDate", "update:opened"],
    data() {
      return {
        firstDateSelected: false,
      };
    },
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
      dateInternal: {
        // the date is different depending the entry point and context
        get() {
          // in mode range (start and end date), if we come from single date
          if (this.mode === "range" && this.dates instanceof Date) {
            // we will select this single date as the start and end dates
            return { ...this.dates };
          }
          // in single mode, if the date was set as multiple
          if (this.mode === "single" && this.dates && this.dates.start instanceof Date) {
            // we will select the start date as being the date
            return this.dates.start;
          }
          // in any other case (for instance for the first opening)
          // let's proceed with the provided value
          return this.date;
        },
        set(value) {
          if (value) {
            this.$emit("setDate", value);
          } else {
            // in case of selecting the same date, the calendar returns null
            // so we emit the last selected date
            // or the last selected start date
            const lastSelectedDate = this.date instanceof Date ? this.dates : this.dates.start;
            this.$emit("setDate", lastSelectedDate);
          }
        },
      },
      modalTitle() {
        return this.mode === "single"
          ? "ETAB.PAGES.DEMANDS.CREATION.@DATE_MODAL_TITLE_SINGLE"
          : "ETAB.PAGES.DEMANDS.CREATION.@DATE_MODAL_TITLE_MULTIPLE";
      },
      shouldShowHelper() {
        return this.mode === "range";
      },
      helperText() {
        return this.firstDateSelected
          ? "ETAB.PAGES.DEMANDS.CREATION.@DATE_MODAL_SELECT_ENDDATE"
          : "ETAB.PAGES.DEMANDS.CREATION.@DATE_MODAL_SELECT_STARTDATE";
      },
    },
    watch: {
      opened(modalOpened) {
        if (modalOpened) {
          this.firstDateSelected = false;
        }
      },
    },
    created() {
      this.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
    },
    methods: {
      onDaySelection(selection) {
        // check if disabled
        // this object is built by v-calendar
        const disabled = selection && selection.attributes && selection.attributes[0] && selection.attributes[0].key === "disabled";
        if (!disabled) {
          this.firstDateSelected = true;
        }
      },
    },
  };
</script>

<style lang="scss">
  .creation-date-modal {
    .extracadabra-modal-body {
      padding: 0;
      text-align: center;
    }
    .creation-date-modal-helper {
      height: 40px;
      margin: 25px 0 0;
      font-family: $common-font-family;
      font-weight: bold;
      text-align: center;
      color: $accent;
    }
  }
</style>
